"use client";

import { Card } from "~/components/v3/shadcn/Card";
import { GetNextAttendDateInfo } from "~/app/community-management/[communitySlug]/memberships/tiers/attendance-limits/actions";
import { format } from "date-fns";

type Props = {
    nextAttendanceDateInfo: GetNextAttendDateInfo | null | undefined;
};

const AttendanceLimitReachedModalContent = ({
    nextAttendanceDateInfo,
}: Props) => {
    if (!nextAttendanceDateInfo) {
        return (
            <div className="flex flex-col gap-4">
                <Card className="bg-v3-N500 p-6">
                    <div className="flex flex-col gap-4">
                        <h6 className="text-white">
                            Unable to Check Attendance Limit
                        </h6>
                        <div className="text-v3-N300">
                            <p>
                                We couldn't determine your current attendance
                                status. Please try again later.
                            </p>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-4">
            <Card className="bg-v3-N500 p-6">
                <div className="flex flex-col gap-4">
                    <h6 className="text-white">
                        Monthly Attendance Limit Reached
                    </h6>
                    <div className="flex flex-col gap-2">
                        <div className="text-v3-N300">
                            <p>
                                You've reached your monthly attendance limit for
                                this membership tier.
                            </p>
                            <div className="mt-4 flex flex-col gap-2">
                                <div className="flex justify-between">
                                    <span>Events attended this month:</span>
                                    <span className="font-medium text-white">
                                        {nextAttendanceDateInfo?.attendedEvents ??
                                            0}
                                    </span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Next available date:</span>
                                    <span className="font-medium text-white">
                                        {nextAttendanceDateInfo?.nextAttendanceDate
                                            ? format(
                                                  new Date(
                                                      nextAttendanceDateInfo.nextAttendanceDate,
                                                  ),
                                                  "MMMM d, yyyy",
                                              )
                                            : "Not available"}
                                    </span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Remaining attendances:</span>
                                    <span className="font-medium text-white">
                                        {
                                            nextAttendanceDateInfo.remainingAttendances
                                        }
                                    </span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Attendance limit per month:</span>
                                    <span className="font-medium text-white">
                                        {
                                            nextAttendanceDateInfo.attendanceLimitPerMonth
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
            <div className="text-sm text-v3-N300">
                <p>
                    You can attend more events when the new month starts or by
                    purchasing a ticket
                </p>
            </div>
        </div>
    );
};

export default AttendanceLimitReachedModalContent;
